import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "user-page common-page"
};
const _hoisted_2 = {
  class: "page-title flex"
};
const _hoisted_3 = {
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "user-table"
};
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { addLoading } from "@/utils/element-method";
import protoPagination from "@/components/proto-pagination.vue";
import { ElMessage } from "element-plus";
import { getUserListApi, setUserVipApi } from "@/service/modules/user";
import userProjectDialog from "./components/user-project-dialog.vue";
import familyProjectDialog from "./components/family-project-dialog.vue";
import Bus from "@/utils/bus";
import uploadProjectDialog from "./components/upload-project-dialog.vue";
import healthNumberDialog from "./components/health-number-dialog.vue";
import useUserStore from "@/store/modules/user";
import { storeToRefs } from "pinia";
import { getDictListById } from "@/service/modules/dict";
export default /*@__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const {
      userProjectDialogVisible,
      familyProjectDialogVisible,
      healthNumberDialogVisible
    } = storeToRefs(userStore);
    const pastMedicalHistoryList = ref([]);
    const bodyTypeList = ref([]);
    const nutritionStatusList = ref([]);
    const exerciseHabitsList = ref([]);
    const dietaryHabitsList = ref([]);
    const smokingStatusList = ref([]);
    const sleepStatusList = ref([]);
    const excretionStatusList = ref([]);
    const userList = ref([]);
    const page = reactive({
      current: 1,
      size: 10
    });
    const total = ref(0);
    const userForm = reactive({
      realname: "",
      mobile: "",
      isVip: null,
      gender: null,
      healthManager: "",
      bloodType: null,
      pastMedicalHistory: null,
      bodyType: null,
      nutritionStatus: null,
      exerciseHabits: null,
      dietaryHabits: null,
      smokingStatus: null,
      sleepStatus: null,
      excretionStatus: null,
      createTime: null,
      startTime: undefined,
      endTime: undefined
    });
    // const userProjectDialogVisible = ref(false)
    const userProjectDialogName = ref("");
    const userProjectDialogMobile = ref();
    // const familyProjectDialogVisible = ref(false)
    const familyProjectDialogId = ref();
    const uploadProjectDialogVisible = ref(false);
    // const healthNumberDialogVisible = ref(false)
    const healthNumberDialogActiveMobile = ref("");
    // 表格引用
    const tableRef = ref(null);
    onMounted(() => {
      getUserList();
      getTypeList();
    });
    // 获取关系列表
    async function getTypeList() {
      try {
        let {
          data
        } = await getDictListById(6);
        pastMedicalHistoryList.value = data.map(item => item.name); //既往病史
      } catch {}
      try {
        let {
          data
        } = await getDictListById(11);
        bodyTypeList.value = data.map(item => item.name); //体型
      } catch {}
      try {
        let {
          data
        } = await getDictListById(12);
        nutritionStatusList.value = data.map(item => item.name); //营养状况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(13);
        exerciseHabitsList.value = data.map(item => item.name); //体育锻炼
      } catch {}
      try {
        let {
          data
        } = await getDictListById(14);
        dietaryHabitsList.value = data.map(item => item.name); //饮食习惯
      } catch {}
      try {
        let {
          data
        } = await getDictListById(15);
        smokingStatusList.value = data.map(item => item.name); //吸烟情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(3);
        sleepStatusList.value = data.map(item => item.name); //睡眠情况
      } catch {}
      try {
        let {
          data
        } = await getDictListById(4);
        excretionStatusList.value = data.map(item => item.name); //排泄情况
      } catch {}
    }
    // 日期变化
    function handleDateChange(val) {
      if (val) {
        userForm.startTime = val[0];
        userForm.endTime = val[1];
      } else {
        userForm.startTime = undefined;
        userForm.endTime = undefined;
      }
    }
    // 客户列表
    async function getUserList() {
      let instance = addLoading(".user-table");
      try {
        let params = {
          ...page
        };
        // delete params.limit
        params = {
          ...params,
          ...userForm
        };
        for (let key in params) {
          let item = params[key];
          if (key === "isVip" && item === 0) {
            continue;
          }
          if (!item) {
            delete params[key];
          }
        }
        console.log(123, "params", params);
        let res = await getUserListApi(params);
        userList.value = res.data.customers;
        total.value = res.data.total;
      } catch {} finally {
        instance.close();
      }
    }
    // 搜索
    function handleSearch() {
      page.current = 1;
      getUserList();
    }
    // 重置
    function handleClear() {
      userForm.realname = "";
      userForm.mobile = "";
      userForm.isVip = null;
      userForm.gender = null;
      userForm.healthManager = "";
      userForm.bloodType = null;
      userForm.pastMedicalHistory = null;
      userForm.bodyType = null;
      userForm.nutritionStatus = null;
      userForm.exerciseHabits = null;
      userForm.dietaryHabits = null;
      userForm.smokingStatus = null;
      userForm.sleepStatus = null;
      userForm.excretionStatus = null;
      userForm.createTime = null;
      userForm.startTime = undefined;
      userForm.endTime = undefined;
      page.current = 1;
      getUserList();
    }
    // 个人档案
    function handleGetProjectByName(item) {
      // userProjectDialogVisible.value = true
      userStore.handleOpenUserProjectDialog();
      userProjectDialogName.value = item.realname;
      userProjectDialogMobile.value = item.mobile;
    }
    // 关闭个人档案弹窗
    function handleCloseUserProjectDialog() {
      // userProjectDialogVisible.value = false
      userStore.handleCloseUserProjectDialog();
      userProjectDialogName.value = "";
    }
    // 家族档案
    function handleGetProjectByFamily(item) {
      // familyProjectDialogVisible.value = true
      userStore.handleOpenFamilyProjectDialog();
      familyProjectDialogId.value = item.mobile;
    }
    // 关闭家族列表
    function handleCloseFamilyProjectDialog() {
      // familyProjectDialogVisible.value = false
      userStore.handleCloseFamilyProjectDialog();
      familyProjectDialogId.value = null;
    }
    function handleUserTableCurrentChange(val) {
      page.current = val;
      getUserList();
    }
    const handleUserTableSizeChange = val => {
      page.size = val;
      getUserList();
    };
    function restData() {
      page.current = 1;
      getUserList();
    }
    function handleUserAdd() {
      router.push("/user/add");
    }
    // 会员服务
    async function handleSetVip(item) {
      console.log("item", item);
      let query = {
        uid: item.uid,
        vipLevel: null
      };
      if (!item.vipLevel) {
        query.vipLevel = 1;
      } else {
        query.vipLevel = 0;
      }
      try {
        await setUserVipApi(query);
        ElMessage.success("操作成功");
        restData();
      } catch {}
    }
    // 上传弹框
    function handleOpenUploadProjectDialog() {
      uploadProjectDialogVisible.value = true;
    }
    function handleCloseUploadProjectDialog() {
      uploadProjectDialogVisible.value = false;
    }
    // 打开健康记录
    function handleOpenHealthNumberDialog(item) {
      healthNumberDialogActiveMobile.value = item.mobile;
      // healthNumberDialogVisible.value = true
      userStore.handleOpenHealthNumberDialog();
    }
    // 关闭健康记录
    function handleCloseHealthNumberDialog() {
      healthNumberDialogActiveMobile.value = "";
      // healthNumberDialogVisible.value = false
      userStore.handleCloseHealthNumberDialog();
    }
    onMounted(() => {
      Bus.on("handleCloseUserProjectDialog", () => {
        console.log("handleCloseUserProjectDialog");
        userProjectDialogVisible.value = false;
      });
      Bus.on("handleOpenUserProjectDialog", () => {
        console.log("handleOpenUserProjectDialog");
        userProjectDialogVisible.value = true;
      });
      Bus.on("handleCloseFamilyProjectDialog", () => {
        familyProjectDialogVisible.value = false;
      });
      Bus.on("handleOpenFamilyProjectDialog", () => {
        console.log("handleOpenFamilyProjectDialog");
        familyProjectDialogVisible.value = true;
      });
      Bus.on("handleCloseHealthNumberDialog", () => {
        healthNumberDialogVisible.value = false;
      });
      Bus.on("handleOpenHealthNumberDialog", () => {
        healthNumberDialogVisible.value = true;
      });
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[15] || (_cache[15] = _createTextVNode(" 客户列表 ")), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        onClick: handleUserAdd,
        type: "primary",
        style: {
          "margin-right": "5px"
        }
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("新增档案")])),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: handleOpenUploadProjectDialog,
        type: "primary"
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("导入档案")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: userForm,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "姓名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "180px"
            },
            modelValue: userForm.realname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userForm.realname = $event),
            placeholder: "请输入姓名",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "性别"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.gender,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => userForm.gender = $event),
            placeholder: "请选择性别",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "男",
              value: "男"
            }), _createVNode(_component_el_option, {
              label: "女",
              value: "女"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "健康管理师"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            style: {
              "width": "180px"
            },
            modelValue: userForm.healthManager,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => userForm.healthManager = $event),
            placeholder: "请输入健康管理师",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "血型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.bloodType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => userForm.bloodType = $event),
            placeholder: "请选择血型",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "A",
              value: "A"
            }), _createVNode(_component_el_option, {
              label: "B",
              value: "B"
            }), _createVNode(_component_el_option, {
              label: "O",
              value: "O"
            }), _createVNode(_component_el_option, {
              label: "AB",
              value: "AB"
            }), _createVNode(_component_el_option, {
              label: "RH",
              value: "RH"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "既往病史"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.pastMedicalHistory,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => userForm.pastMedicalHistory = $event),
            placeholder: "请选择既往病史",
            style: {
              "width": "180px"
            },
            clearable: "",
            filterable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastMedicalHistoryList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "体型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.bodyType,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => userForm.bodyType = $event),
            placeholder: "请选择体型",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyTypeList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "营养状况"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.nutritionStatus,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => userForm.nutritionStatus = $event),
            placeholder: "请选择营养状况",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nutritionStatusList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "体育锻炼"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.exerciseHabits,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => userForm.exerciseHabits = $event),
            placeholder: "请选择体育锻炼",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exerciseHabitsList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "饮食习惯"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.dietaryHabits,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => userForm.dietaryHabits = $event),
            placeholder: "请选择饮食习惯",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dietaryHabitsList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "吸烟情况"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.smokingStatus,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => userForm.smokingStatus = $event),
            placeholder: "请选择吸烟情况",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smokingStatusList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "睡眠情况"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.sleepStatus,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => userForm.sleepStatus = $event),
            placeholder: "请选择睡眠情况",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sleepStatusList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "排泄情况"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: userForm.excretionStatus,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => userForm.excretionStatus = $event),
            placeholder: "请选择排泄情况",
            style: {
              "width": "180px"
            },
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(excretionStatusList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "创建时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: userForm.createTime,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => userForm.createTime = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "YYYY-MM-DD",
            onChange: handleDateChange,
            style: {
              "width": "320px"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleClear
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSearch
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: userList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        style: {
          "width": "100%"
        }
      }, {
        empty: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          "min-width": "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.current - 1) * page.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "realname",
          label: "姓名",
          "show-overflow-tooltip": "",
          "min-width": "80"
        }), _createVNode(_component_el_table_column, {
          prop: "openid",
          label: "微信openid",
          "show-overflow-tooltip": "",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号码",
          "show-overflow-tooltip": "",
          "min-width": "110"
        }), _createVNode(_component_el_table_column, {
          label: "是否会员",
          "min-width": "80"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: Number(scope.row.vipLevel) >= 1 ? 'success' : 'error'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(Number(scope.row.vipLevel) >= 1 ? "是" : "否"), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "institutionName",
          label: "绑定机构",
          "show-overflow-tooltip": "",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "healthManager",
          label: "健康管理师",
          "show-overflow-tooltip": "",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          "min-width": "100",
          prop: "archivalMembers",
          label: "档案成员数",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          "min-width": "100",
          prop: "archivalNums",
          label: "档案总数",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "healthMembers",
          label: "健康记录成员数",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          "min-width": "120",
          prop: "healthNums",
          label: "健康记录总数",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "show-overflow-tooltip": "",
          "min-width": "160"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "260",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleGetProjectByName(scope.row),
            type: "primary"
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("个人档案")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleGetProjectByFamily(scope.row),
            type: "warning"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("家族成员")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "info",
            onClick: $event => handleOpenHealthNumberDialog(scope.row)
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("健康记录")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: !scope.row.vipLevel ? 'success' : 'error',
            onClick: $event => handleSetVip(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(!scope.row.vipLevel ? "设为会员" : "取消会员"), 1)]),
            _: 2
          }, 1032, ["type", "onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleUserTableCurrentChange,
        onSizeChange: handleUserTableSizeChange
      }, null, 8, ["page", "total"])]), _createVNode(userProjectDialog, {
        "dialog-visible": _unref(userProjectDialogVisible),
        name: userProjectDialogName.value,
        mobile: userProjectDialogMobile.value,
        onCloseDialog: handleCloseUserProjectDialog
      }, null, 8, ["dialog-visible", "name", "mobile"]), _createVNode(familyProjectDialog, {
        "dialog-visible": _unref(familyProjectDialogVisible),
        id: familyProjectDialogId.value,
        onCloseDialog: handleCloseFamilyProjectDialog
      }, null, 8, ["dialog-visible", "id"]), _createVNode(uploadProjectDialog, {
        dialogVisible: uploadProjectDialogVisible.value,
        onCloseDialog: handleCloseUploadProjectDialog,
        onRestData: restData
      }, null, 8, ["dialogVisible"]), _createVNode(healthNumberDialog, {
        dialogVisible: _unref(healthNumberDialogVisible),
        mobile: healthNumberDialogActiveMobile.value,
        onCloseDialog: handleCloseHealthNumberDialog
      }, null, 8, ["dialogVisible", "mobile"])]);
    };
  }
});